import { Outlet } from '@tanstack/react-router';

const Router = () => <Outlet />;

export default Router;
